module.exports = `${require.publicPath}certificate-bg4.3e1baf65.png`;